import { render, staticRenderFns } from "./SelectColumns.vue?vue&type=template&id=2fda5d5c"
import script from "./SelectColumns.vue?vue&type=script&lang=js"
export * from "./SelectColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports